import { atomWithStorage } from "jotai/utils";
import { StoreKeys } from "./store-keys";
import { Company } from "@/types";
/**
 * Interface for empresa data
 */
// export interface Company {
//   id: number | string | null;
//   name: string;
// }

export const companyAtom = atomWithStorage<Company | null>(
  `Xtremis_CarbonTech_${StoreKeys.Company}`,
  null,
);
